@if (!isInitialLoading()) {
  <microsec-loading-overlay [isLoading]="isLoading()">
    <div class="flex flex-col gap-4">
      <app-update-analyzer-rules-form
        #updateAnalyzerRulesForm
        [tipConfig]="tipConfig"
        [isLoading]="isLoading"
        (getConfigDataEvent)="getConfigData($event?.isDefault, $event?.isStatusUpdated)" />
      <app-platform-configuration-form
        #platformConfigForm
        [tipConfig]="tipConfig"
        [isLoading]="isLoading"
        [isFirstLoad]="isFirstLoad"
        (getConfigDataEvent)="getConfigData($event)" />
    </div>
  </microsec-loading-overlay>
}
